module.exports = __webpack_public_path__ + "static/img/Tony-Francis.9d853ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tony-Francis.jpg
// module id = qPF1
// module chunks = 0